export const config = {
  src: [
    'audiosprites/audio.ogg',
    'audiosprites/audio.mp3',
  ],
  sprite: {
    base_to_fs_start: [
      0,
      3030.9977324263036,
    ],
    big_win: [
      5000,
      6412.675736961451,
    ],
    button_spin: [
      13000,
      660.4308390022684,
    ],
    expanding_wild: [
      15000,
      1769.3424036281194,
    ],
    free_bet_big_win: [
      18000,
      1362.3129251700695,
    ],
    free_bet_mega_win: [
      21000,
      2207.913832199548,
    ],
    free_bet_total_win: [
      25000,
      973.3560090702938,
    ],
    free_bet_ultra_win: [
      27000,
      1297.4149659863947,
    ],
    free_spin_ambient: [
      30000,
      32333.287981859412,
    ],
    free_spin_music: [
      64000,
      66446.80272108843,
    ],
    free_spin_start: [
      132000,
      8445.48752834467,
    ],
    fs_end_to_base: [
      142000,
      3328.253968253961,
    ],
    fs_game_to_fs_end: [
      147000,
      4389.569160997724,
    ],
    fs_start_to_fs_game: [
      153000,
      4740.000000000009,
    ],
    inside_buttons: [
      159000,
      552.8798185941071,
    ],
    main_ambient: [
      161000,
      65885.96371882084,
    ],
    main_music: [
      228000,
      130491.83673469389,
    ],
    mega_win: [
      360000,
      8383.446712018156,
    ],
    outside_buttons: [
      370000,
      1553.265306122455,
    ],
    reel_spin: [
      373000,
      2218.5941043084085,
    ],
    reel_stop_01: [
      377000,
      246.25850340135003,
    ],
    reel_stop_02: [
      379000,
      226.23582766442496,
    ],
    reel_stop_03: [
      381000,
      230.15873015873467,
    ],
    reel_stop_04: [
      383000,
      225.41950113378562,
    ],
    reel_stop_05: [
      385000,
      165.73696145127315,
    ],
    regular_win: [
      387000,
      1758.1179138322227,
    ],
    scatter_stop: [
      390000,
      1701.360544217664,
    ],
    sticky_wild: [
      393000,
      3221.1111111110995,
    ],
    tap_to_play: [
      398000,
      10393.129251700657,
    ],
    ultra_win: [
      410000,
      5712.562358276671,
    ],
    wild_stop: [
      417000,
      677.7324263038622,
    ],
  },
}
